define('SageDotCom/DataLayer/Global/forms',[
    'jquery',
    'SageDotCom/DataLayer/tealium',
    'SageDotCom/DataLayer/Events/Forms/fieldCompletion',
    'SageDotCom/DataLayer/Events/Forms/fieldCompletionError',
    'SageDotCom/DataLayer/Events/Forms/formVisible',
    'SageDotCom/DataLayer/Events/Forms/formStart',
    'SageDotCom/DataLayer/Events/Forms/formSubmitError',
    'SageDotCom/DataLayer/Events/Forms/formSubmitSuccess',
    'SageDotCom/DataLayer/Events/Forms/formSubmitSuccessTailored',
    'SageDotCom/DataLayer/Events/Forms/formStepCompleteError',
    'SageDotCom/DataLayer/Events/Forms/freeTrialFormSubmitSuccess',
    'SageDotCom/DataLayer/Events/Forms/navigationButtonClick',
    'SageDotCom/DataLayer/Util/trackingHelper',
    "jqueryValidate",
    "jqueryValidateUnobtrusive",
    "SageDotCom/DataLayer/Util/jQueryExtensions"
],
    function ($, analytics, fieldCompletion, fieldCompletionError, formVisible, formStart, formSubmitError, formSubmitSuccess, formSubmitSuccessTailored, formStepCompleteError, freeTrialFormSuccess, formNavigation, trackingHelper) {

        function globalFormTracking() { }

        function captureFormStart(form, field) {
            var formStartVal = $(form).data("start");
            if (formStartVal === "true") {
                $(form).data("start", "false");
                var formStartData = formStart.GenerateEventMetadata($(field));
                analytics.event(formStartData);
            }
        }

        globalFormTracking.prototype.initialize = function initialize() {

            var componentRegistrations = [];

            $('form[id*="fxb"]').each(function (formIndex, form) {
                var $currentForm = $(this); // Store the current form reference

                var pageData = {
                    "page_form_exists": "true",
                    "page_form_content_name": $(form).attr("class")
                };
                analytics.registerPageData(pageData);

                var formId = $(form).attr("id");

                $(form).data("start", "true");
                componentRegistrations.push({ obj: formId, name: formStart.getName() });
                componentRegistrations.push({ obj: formId, name: formSubmitSuccess.getName() });
                componentRegistrations.push({ obj: formId, name: formSubmitError.getName() });
                if ($(form).hasClass("free-trial-form")) {
                    $(":submit", form).click(function () {
                        if ($(form).valid()) {
                            var formSubmitSuccessData = freeTrialFormSuccess.GenerateEventMetadata(form);
                            analytics.event(formSubmitSuccessData);
                        }
                    });

                }
                //50% visibility
                var options = {
                    root: null,
                    threshold: 0.5
                };

                function checkIfVisible(entries) {
                    entries.map((entry) => {
                        if (entry.isIntersecting) {
                            var formVisibleData = formVisible.GenerateEventMetadata(form);
                            analytics.event(formVisibleData);
                            observer.unobserve(entry.target);
                        }
                    });
                }

                var observer = new IntersectionObserver(checkIfVisible, options);

                var progressBar;
                if ($(form).find(".product-trial-form").length > 0) {
                    progressBar = $(".product-trial-header .progress-bar-holder");
                }
                else if ($(form).find(".privacy-rights-request-form").length > 0) {
                    progressBar = $(".score-style-box.privacy-rights-request .progress-bar-holder");
                }
                else {
                    progressBar = $(form).siblings(".progress-bar-holder");
                }

                if (progressBar.length > 0) {
                    //multistep form so need to observe every step in the form
                    [].forEach.call(form.querySelectorAll(".current-section, .hidden-section"), function (el) {
                        observer.observe(el);
                    });
                }
                else {
                    observer.observe(form);
                }
                //50% visibility end

                // Navigation events - Bind only to buttons in the current form
                $currentForm.find(".form-next-btn, .form-back-btn").click(function (event) {
                    var data = formNavigation.GenerateEventMetadata($(event.currentTarget));
                    analytics.event(data);

                    if ($(event.currentTarget).hasClass("form-next-btn") && $(event.currentTarget).attr("type") !== "submit" && $currentForm.find(".current-section .input-validation-error").length >= 1) {
                        // must be a form validation error but not a form submit button
                        // send the form_step_N_complete error event
                        var stepErrorData = formStepCompleteError.GenerateEventMetadata(form, $(event.currentTarget));
                        if (stepErrorData !== null) {
                            analytics.event(stepErrorData);
                        }

                    }

                    return;
                });


                //submissions
                $(form).submit(function (event) {
                    if (window.location.href.indexOf("error/sageid") > 0)
                        return;

                    var form = $(event.currentTarget)[0];

                    if ($(form).valid()) {
                        //form tailored with level 5 value populated
                        var formSubmitSuccessData;
                        if ($(form).find(".tailored-form").length > 0) {
                            formSubmitSuccessData = formSubmitSuccessTailored.GenerateEventMetadata(form);
                            analytics.event(formSubmitSuccessData);
                        } else if (!$(form).hasClass("free-trial-form")) { // free trial form is handled differently
                            formSubmitSuccessData = formSubmitSuccess.GenerateEventMetadata(form);
                            analytics.event(formSubmitSuccessData);
                        }
                    } else {
                        var formSubmitErrorData = formSubmitError.GenerateEventMetadata(form);
                        analytics.event(formSubmitErrorData);
                    }
                });

                //fields
                $(form).find(':text, :file, input[type=tel], input[type=email], textarea').each(function (fieldIndex, field) {

                    componentRegistrations.push({ obj: field, name: fieldCompletion.getName() });

                    $(field).on("focus", function (event) {
                        var $field = $(event.currentTarget);
                        $field.data("oldValue", $field.val());

                        captureFormStart(form, field);
                    });
                    $(field).on("blur", function (event) {
                        var $field = $(event.currentTarget);
                        var oldValue = $field.data("oldValue");
                        var inputValue = $field.val();

                        if ((oldValue !== inputValue) && inputValue.length > 0) {
                            var fieldCompletionData = fieldCompletion.GenerateEventMetadata($field);
                            analytics.event(fieldCompletionData);
                        }
                        if (!$(field).valid() || $(field).hasClass("is-invalid")) {
                            var fieldCompletionErrorData = fieldCompletionError.GenerateEventMetadata($field);
                            analytics.event(fieldCompletionErrorData);
                        }
                    });
                });
                $(form).find('select').each(function (selectIndex, select) {
                    $(select).focus(function () {
                        captureFormStart(form, select);
                    });

                    componentRegistrations.push({ obj: select, name: fieldCompletion.getName() });

                    $(select).change(function (event) {
                        var data = fieldCompletion.GenerateEventMetadata($(event.currentTarget));
                        analytics.event(data);
                    });
                });
                $(form).find(':checkbox').each(function (index, checkbox) {
                    $(checkbox).focus(function () {
                        captureFormStart(form, checkbox);
                    });

                    componentRegistrations.push({ obj: checkbox, name: fieldCompletion.getName() });

                    $(checkbox).change(function (event) {
                        var data = fieldCompletion.GenerateEventMetadata($(event.currentTarget));
                        analytics.event(data);
                    });
                });
                $(form).find('.select-all, .deselect-all').each(function (index, btn) {
                    $(btn).focus(function () {
                        captureFormStart(form, btn);
                    });

                    componentRegistrations.push({ obj: btn, name: fieldCompletion.getName() });

                    $(btn).click(function (event) {
                        var data = fieldCompletion.GenerateEventMetadata($(event.currentTarget));
                        analytics.event(data);
                    });
                });
                $(form).find('input[type=radio]').each(function (index, radio) {
                    componentRegistrations.push({ obj: radio, name: fieldCompletion.getName() });

                    $(radio).change(function (event) {
                        captureFormStart(form, radio);

                        var data = fieldCompletion.GenerateEventMetadata($(event.currentTarget));
                        analytics.event(data);
                    });
                });
            });

            componentRegistrations.forEach(function (elem) {
                trackingHelper.registerTracking(elem.obj, elem.name);
            });
        }

        return new globalFormTracking();
    });

